import type { Provider as vnxProvider } from "@blueskydataplatform/shared-ui/types/providers.types";
import { createContext, useContext, useState } from "react";
import { DEFAULT_MCP_PERMISSIONS } from "./mcp-default-permissions";

// eslint-disable-next-line react-refresh/only-export-components
export const VIA_NEXUS_PROVIDER: vnxProvider = {
  id: "viaNexus",
  name: "viaNexus",
  description: "viaNexus is a platform for building and deploying AI applications.",
  url: "https://vianexus.com",
  logo: {
    light: "/images/logos/ViaNexus-Horizontal-Logo.png",
    dark: "/images/logos/ViaNexus-Horizontal-Logo-dark.png",
    altText: "viaNexus logo",
  },
  mcp: {
    permissions: DEFAULT_MCP_PERMISSIONS,
  },
};

const McpProvidersContext = createContext<{
  provider: vnxProvider | null | undefined;
  setProvider: (provider: vnxProvider | null | undefined) => void;
}>({
  provider: null,
  setProvider: () => {},
});

// eslint-disable-next-line react-refresh/only-export-components
export const useMcpProvider = () => {
  return useContext(McpProvidersContext);
};

export const McpProvidersProvider = ({ children }: { children: React.ReactNode }) => {
  const [provider, setProvider] = useState<vnxProvider | null | undefined>(null);

  return <McpProvidersContext.Provider value={{ provider, setProvider }}>{children}</McpProvidersContext.Provider>;
};
